/** Where to send users immediately after login or registration. */
export function getPostAuthPath() {
  try {
    if (localStorage.getItem('subsecai_onboarding_complete') === 'true') {
      return '/dashboard';
    }
    return '/onboarding';
  } catch {
    return '/dashboard';
  }
}

/** One-time API key from registration (plaintext shown once). */
export function consumePendingApiKey() {
  try {
    const key = sessionStorage.getItem('subsecai_pending_api_key');
    if (key) {
      sessionStorage.removeItem('subsecai_pending_api_key');
      return key;
    }
  } catch {
    // ignore
  }
  return null;
}

export function storePendingApiKey(apiKey) {
  if (!apiKey) return;
  try {
    sessionStorage.setItem('subsecai_pending_api_key', apiKey);
  } catch {
    // ignore
  }
}
